import { PokeLoading } from "src/components/Loading"

export default function Loading() {
  return <PokeLoading />
}
